module.exports = __webpack_public_path__ + "static/img/comprehensive01.380fbadf.png";